import {
  getFirestore,
  onSnapshot,
  doc,
  setDoc,
  updateDoc,
  collection,
  serverTimestamp,
  where,
  query,
  orderBy,
  deleteDoc,
  getDocs,
} from "firebase/firestore";
import { TYPES } from "./voucher.type";
import { REF } from "../ref";
import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "../ref";
import { app } from "../../config/config";
import { makeOrderId } from "../../utils/generate.function";
import moment from "moment";

const firestore = getFirestore(app);
const functions = getFunctions(app, REGION);

// --------------- Add a new voucher -----------------
export const addVoucher =
  ({ vouchers, sender, branch, note }, callback) =>
  (dispatch) => {
    const addVoucher = httpsCallable(functions, "api-voucher-admin-add");
    addVoucher({ vouchers, sender, branch, note })
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error,
          });
        }
      });
  };

// ---------------- Add a Voucher Package --------------
export const addVoucherPackage =
  ({ dataPackage }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
    const id = doc(cRef).id;
    const dRef = doc(cRef, id);
    const expiredDate = dataPackage?.expiry;
    const { amount, step } = expiredDate;
    const packageId = dataPackage?.packageId;
    const data = {
      ...dataPackage,
      createAt: serverTimestamp(),
      id,
      expiry: moment().add(amount, step).toDate(),
    };
    checkPackageId(packageId).then((response) => {
      if (response.status === 200) {
        setDoc(dRef, data, { merge: true })
          .then(() => {
            if (callback) {
              callback({
                status: 200,
              });
            }
          })
          .catch((error) => {
            if (callback) {
              callback({
                status: 500,
                data: error.message,
              });
            }
          });
      } else {
        if (callback) {
          callback(response);
        }
      }
    });
  };

// ------------ snap all voucher package ---------------
let voucherPackageSub = [];
export const snapAllVoucherPackage =
  ({ branchId }, callback) =>
  (dispatch) => {
    getAllVoucherPackageSuccess(dispatch, null);
    const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
    // const c0 = where("owner", "==", ownerId);
    const c1 = where("branch", "==", branchId);
    const qRef = query(cRef, c1);
    const sub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        getAllVoucherPackageSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    voucherPackageSub.push(sub);
  };

export const unSnapVoucherPackage = () => (dispatch) => {
  voucherPackageSub.forEach((subscriber) => {
    subscriber();
  });
  voucherPackageSub.lenght = 0;
};

// ----------------- dispatch --------------------
const getAllVoucherPackageSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_ALL_VOUCHER_PACKAGE_SUCCESS,
    payload: data,
  });
};

// -------------- Make order ID for voucher Id -------------
export const getVoucherIdRandom = (callback) => (dispatch) => {
  const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
  const id = makeOrderId(6);
  const c1 = where("packageId", "==", id);
  const dRef = query(cRef, c1);
  getDocs(dRef)
    .then((snapshot) => {
      if (snapshot.docs.length === 0) {
        if (callback) {
          callback({ id });
        }
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};

// ---------- Check the duplicate Package Id ---------
const checkPackageId = (packageId) => {
  const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
  const c1 = where("packageId", "==", packageId);
  const qRef = query(cRef, c1);
  return getDocs(qRef)
    .then((snapshot) => {
      if (snapshot.docs.length === 0) {
        return {
          status: 200,
        };
      } else {
        return {
          status: 500,
          data: "Duplicate package Id",
        };
      }
    })
    .catch((error) => {
      return {
        status: 500,
        data: error,
      };
    });
};

// ---------- Deactivate the Voucher Id ---------

export const archiveVoucherById =
  ({ voucherId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
    const dRef = doc(cRef, voucherId);
    const update = {
      active: false,
    };
    updateDoc(dRef, update)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      });
  };

// ---------- Activate the Voucher Id ---------
export const activateVoucherById =
  ({ voucherId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
    const dRef = doc(cRef, voucherId);
    const update = {
      active: true,
    };
    updateDoc(dRef, update)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      });
  };

// ---------- Delete the Voucher Id ---------

export const deleteVoucherById =
  ({ voucherId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
    const dRef = doc(cRef, voucherId);
    deleteDoc(dRef)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        if (callback) {
          callback({
            status: 500,
            data: error.message,
          });
        }
      });
  };

// ---------- VOUCHER QUERY ---------

// ---------- getVouchersByPackageId ---------
let voucherSub = [];
export const snapVouchersByPackageId =
  ({ packageId, branchId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER);
    const c0 = where("voucherPackage", "==", packageId);
    const c1 = where("branch", "==", branchId);
    const c2 = orderBy("createAt", "desc");
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        // console.log("data-back", data);
        selectVouchersSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });

    voucherSub.push(unsub);
  };

export const unSnapVoucher = () => (dispatch) => {
  voucherSub.forEach((subscriber) => {
    subscriber();
  });

  voucherSub.length = 0;
};

// ---------- get detail package success ---------
export const getDetailPackageById =
  ({ packageId }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
    const c0 = where("packageId", "==", packageId);
    const qRef = query(cRef, c0);
    return getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const [data] = snapshot.docs.map((doc) => doc.data());
        selectDetailPackageSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
  };

// ---------- update voucher Package the Voucher Id ---------
export const updateVoucherPackage =
  ({ packageId, data, update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER_PACKAGE);
    const dRef = doc(cRef, packageId);
    const expiredDate = update?.expiry;
    const { amount, step } = expiredDate;

    const updated = {
      ...data,
      ...update,
      updateAt: serverTimestamp(),
      expiry: moment().add(amount, step).toDate(),
    };
    updateDoc(dRef, updated)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err,
          });
        }
      });
  };

// ---------------- Add a Voucher From Admin --------------
export const addVoucherAdmin =
  ({ voucher }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.VOUCHER);
    const id = doc(cRef).id;
    const dRef = doc(cRef, id);
    const data = {
      ...voucher,
      id,
      createAt: serverTimestamp(),
    };

    //Check duplicate code;
    const codeId = makeOrderId(5);
    const code = `${voucher?.shopId}-${voucher?.voucherPackage}-${codeId}`;
    const c0 = where("code", "==", code);
    const qRef = query(cRef, c0);
    getDocs(qRef).then((snapshot) => {
      // no code duplicate;
      if (snapshot.docs.length === 0) {
        setDoc(dRef, data, { merge: true })
          .then(() => {
            if (callback) {
              callback({ status: 200 });
            }
          })
          .then((error) => {
            if (callback) {
              callback({
                status: 500,
                data: error,
              });
            }
          });
      }
    });
  };

// ---------- dispatch ---------
const selectVouchersSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_VOUCHER_SUCCESS,
    payload: data,
  });
};

// ---------- dispatch ---------
const selectDetailPackageSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_PACKAGE_DETAIL_SUCCESS,
    payload: data,
  });
};

// ---------- selectAllRedeem by branch ---------
let redeemSub = [];
export const snapRedeemByBranch =
  ({ branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.REDEEM);
    const c0 = where("branch", "==", branch);
    const qRef = query(cRef, c0);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectRedeemSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    redeemSub.push(unsub);
  };

export const unSnapRedeem = () => (dispatch) => {
  redeemSub.forEach((subscriber) => {
    subscriber();
  });

  redeemSub.length = 0;
};

// ---------- dispatch ---------
const selectRedeemSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_REDEEM_SUCCESS,
    payload: data,
  });
};

// ---------- get  history redeem by Codes  ---------
export const getHistoryRedeem =
  ({ code }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.REDEEM);
    const c0 = where("code", "==", code);
    const qRef = query(cRef, c0);

    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (callback) {
          callback(data);
        }
      }
    });
  };

// ----------- snapVoucherByDate -------------- //
let voucherDateSub = [];
export const snapVoucherByBranchAndDate =
  ({ branch, date }, callback) =>
  (dispatch) => {
    selectVoucherByDateSuccess(dispatch, null);
    // console.log("trigger");
    const start = moment(date, "DD/MM/YYYY")?.startOf("days").toDate();
    const end = moment(date, "DD/MM/YYYY")?.endOf("days").toDate();
    const cRef = collection(firestore, REF.VOUCHER);
    const c0 = where("branch", "==", branch);
    const c1 = where("createAt", ">=", start);
    const c2 = where("createAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectVoucherByDateSuccess(dispatch, data);
        if (callback) {
          callback(data);
        }
      }
    });

    voucherDateSub.push(unsub);
  };

export const unSnapVoucherByDate = () => (dispatch) => {
  voucherDateSub?.forEach((subscriber) => {
    subscriber();
  });

  voucherDateSub.length = 0;
};

// ---------------- dispatch ------------- //
const selectVoucherByDateSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_VOUCHER_BYDATE_SUCCESS,
    payload: data,
  });
};

// ----------- snapVoucherByDate -------------- //
let voucherRedeemDateSub = [];
export const snapVoucherRedeemByBranchAndDate =
  ({ branch, date }, callback) =>
  (dispatch) => {
    selectVoucherRedeemByDateSuccess(dispatch, null);
    const start = moment(date, "DD/MM/YYYY")?.startOf("days").toDate();
    const end = moment(date, "DD/MM/YYYY")?.endOf("days").toDate();
    const cRef = collection(firestore, REF.REDEEM);
    const c0 = where("branch", "==", branch);
    const c1 = where("createAt", ">=", start);
    const c2 = where("createAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectVoucherRedeemByDateSuccess(dispatch, data);
        if (callback) {
          callback(data);
        }
      }
    });

    voucherRedeemDateSub.push(unsub);
  };

export const unSnapVoucherRedeemByDate = () => (dispatch) => {
  voucherRedeemDateSub?.forEach((subscriber) => {
    subscriber();
  });

  voucherRedeemDateSub.length = 0;
};

// ---------------- dispatch ------------- //
const selectVoucherRedeemByDateSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_VOUCHER_REDEEM_BYDATE_SUCCESS,
    payload: data,
  });
};
